/**
 * Custom 404 Error Page
 * https://nextjs.org/docs/advanced-features/custom-error-page#404-page
 */
import clsx from 'clsx'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import useLengthOfLongestWord from '../hooks/useLengthOfLongestWord'

const Cta = dynamic(() => import('../components').then(mod => mod.Cta))
const Heading = dynamic(() => import('../components').then(mod => mod.Heading))
const Container = dynamic(() => import('../components').then(mod => mod.Container))
const GridContainer = dynamic(() => import('../components').then(mod => mod.GridContainer))

import getGlobalData from '../services/cacheGlobalData'

export default function Custom404() {
  const heading = 'Oops!'
  const subHeading = 'The page you are looking for is missing!'
  const ctaObject = {
    label: 'Go to Homepage',
    type: 'internal',
    url: [{ uri: '/' }],
  }

  const hLengthMax = useLengthOfLongestWord(heading)
  const shLengthMax = useLengthOfLongestWord(subHeading)

  return (
    <Container>
      <Head>
        <title>Page Not Found</title>
      </Head>
      <GridContainer className='hero-pt mb-120 md:mb-220'>
        <div className='col-span-4 md:col-span-5 md:col-start-2'>
          <Heading
            semantics='h1'
            text={heading}
            className={clsx(
              'mb-20 mt-40 text-5xl -tracking-5.5 uppercase md:-ml-10 md:text-7xl md:-tracking-4.5',
              hLengthMax > 10 ? 'h1-scale-down-A' : hLengthMax > 8 && 'h1-scale-down-B'
            )}
          />
          <Heading
            semantics='h2'
            text={subHeading}
            className={clsx(
              'mb-60 text-3xl-A -tracking-3 uppercase',
              shLengthMax > 10 ? 'h2-scale-down-A' : shLengthMax > 8 && 'h2-scale-down-B'
            )}
          />
          <Cta cta={ctaObject} />
        </div>
      </GridContainer>
    </Container>
  )
}

export async function getStaticProps() {
  const globalData = await getGlobalData()

  return { props: { globalData } }
}
